import React from 'react';
import { Box } from '@mui/material';

import Webinar from '../../images/Icons/Webinar.svg';
import Webcast from '../../images/Icons/Webcast.svg';
import Podcast from '../../images/Icons/Podcast.svg';
import Blocked from '../../images/Icons/Blocked.svg';
import Series from '../../images/Icons/Series.svg'
import DryRun from '../../images/Icons/DryRun.svg'
import LiveEvent from '../../images/Icons/DryRun.svg'

interface IconCustomProps {
  size?: number;
  type: string;
  alt?: string;
  marginRight?: string;
  marginLeft?: string;
}

export const IconCustom: React.FC<IconCustomProps> = ({ 
  size = 14, 
  type, 
  alt = null,
  marginRight = '4px',
  marginLeft = '4px'
}) => {

  const getEventIcon = (eventType: string) => {
    const icons: Record<string, string> = {
      Webinar,
      Webcast,
      Podcast,
      Blocked,
      Series,
      DryRun,
      LiveEvent
    }

    return icons[eventType] || '';
  };

  const altText = alt || type;
  const srcName = type?.replace(/\s+/g, '') || '';

  return (
    <Box
      component='img'
      src={getEventIcon(srcName)}
      alt={altText + ' icon'}
      sx={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        ...(marginRight && { mr: marginRight }),
        ...(marginLeft && { ml: marginLeft })
      }}
    />
  );
}; 